import { render, staticRenderFns } from "./BlockType19Grid.vue?vue&type=template&id=278bfd60&scoped=true&"
import script from "./BlockType19Grid.vue?vue&type=script&lang=ts&"
export * from "./BlockType19Grid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType19Grid.vue?vue&type=style&index=0&id=278bfd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278bfd60",
  null
  
)

export default component.exports